import { PRIME_VIDEO_OBJECT } from '../../../constants/primeVideoConst';

// リファレンス: https://support.eq.stream.co.jp/hc/ja/articles/115008543548-PlayerFactoryIF%E3%82%AF%E3%83%A9%E3%82%B9

// 型
interface InsertVideo {
  (
    movieId: string,
    idName: string,
    option?: typeof DEFAULT_OPTION
  ): {
    accessor: VideoAccessor;
  };
}

export interface VideoAccessor {
  getCurrentTime: () => number;
  getTotalTime: () => number;
  addEventListener: (type: string, callback: () => void) => void;
  removeEventListener: (type: string, callback: () => void) => void;
  play: () => void;
  pause: () => void;
  state: 'landing' | 'playing' | 'complete' | 'paused' | undefined;
  progressRate: number;
  isLanding: boolean;
}

export interface PercentageArrival {
  zero: number;
  ten: number;
  forty: number;
  seventy: number;
}

export type ActionType =
  | { type: 'zero' }
  | { type: 'ten' }
  | { type: 'forty' }
  | { type: 'seventy' };

// 定数
export const PERCENTAGE = {
  ZERO: 0,
  TEN: 0.1,
  FORTY: 0.4,
  SEVENTY: 0.7,
  COMPLETE: 1,
};

export const initialState = {
  zero: false,
  ten: false,
  forty: false,
  seventy: false,
};

export const percentageArrival: PercentageArrival = {
  zero: PERCENTAGE.ZERO,
  ten: PERCENTAGE.TEN,
  forty: PERCENTAGE.FORTY,
  seventy: PERCENTAGE.SEVENTY,
};

export const getPrimeVideoSetting = () => {
  const isProduction = window.location.hostname === 'doda.jp';
  return PRIME_VIDEO_OBJECT[isProduction ? 'production' : 'stage'];
};

export const DEFAULT_OPTION = {
  rp: 'fit', // レスポンシブ対応
  hp: 360, // 高さpx
  ip: 'on', // 自動再生の有無
  il: 'off', // インバウンドリンクの有無
  is: 'off', // 初期音声の有無
  pr: '', // 速度設定
  sn: '', // 表示するSNSボタンのリスト
  tg: 'off', // タグ表示の有無
  vc: 'on', // 音声ミュート/音量調節の有無
  ti: 'off', // タイトル表示の有無
  wp: 640, // 横幅 px
  skb: 'off', // 秒数送り／戻しボタンの秒数指定
};

// 動画を挿入
export const insertVideo: InsertVideo = (
  movieId,
  idName,
  option = DEFAULT_OPTION
) => {
  // jstream_t3: CDNで読み込まれるメソッド
  return window.jstream_t3.PlayerFactoryIF.create(
    {
      b: getPrimeVideoSetting().PRIME_MOVIE_JSTREAM_PLAYER_URL,
      c: getPrimeVideoSetting().PRIME_MOVIE_JSTREAM_CONTRACT_ID,
      m: movieId,
      s: { ...DEFAULT_OPTION, ...option },
    },
    idName
  );
};

// 動画を削除
export const deleteVideo = (dom: HTMLIFrameElement | null | undefined) => {
  if (dom) dom.remove();
};
